module.exports = __webpack_public_path__ + "static/RootSans-4LightItalic-f5b136d976574f4128a8dfc195f155ac.woff";